import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ReasonFormData } from '../../models/classes/ApplicationStep1.class';
import { P2Accordion, P2Alert, P2Button, P2DateSelector, P2TextInput, P2TextLabel } from 'react-bootstrap-common-script';
import { useForm } from '../../hooks/use-form';
import { Dropdown } from '../dropdown';
import { incomingOwnerCitizenshipDropdownItems, incomingOwnerRelatedToAboveItems, maritalStatusDropdownItems, nationalityDropdownItems, raceDropdownItems, sexDropdownItems } from '../../utils/shared-dropdown';
import RadioGroup from '../form/grouped/radio/radio-group';
import { isRelatedToOwner } from '../../utils/shared-radio';
import { HoldingOccupier } from '../../models/polymer/HoldingOccupier.model';
import { validateIndividualHoldingOccupier } from '../../utils/validator';
import { Occupier } from '../../models/polymer/Occupier.model';
import { useAppDispatch } from '../../redux/hook';
import SingpassMyInfo from '../singpass/singpass-myinfo';
import { retrieveMyInfoByNRIC } from '../../redux/slices/authentication-slice';
import { LottieLoader } from '../loader';
import useRetrieveMyInfo from '../../hooks/use-retrieve-myinfo';
import { MyInfo } from '../../models/polymer/MyInfo.model';
import AccordionTitle from './new-owner-accordions-components/accordion-title';
import SpouseForm from './spouse-form';
import { PolymerCrypto } from '../../utils/encryptor';
import { namePattern } from '../../utils/shared-pattern';
import { Owner } from '../../models/polymer/Owner.model';
import IdForm from './id-form';
import { IDTypeEnum } from '../../models/enum/id-type.enum';
import { ResidentialStatusEnum } from '../../models/enum/residential-status.enum';


interface NewOccupierAccordionProps {
  proposed_nric?: string[],
  incoming_owners?: Owner[],
  // variant?: "existing" | "new" | undefined;
  item: HoldingOccupier;
  reasonValues?: ReasonFormData;
  isIncoming?: boolean;
  onRemove?: () => void;
  onAdd?: () => void;
  onUpdate?: () => void;
  onToggle?: (isOpen: boolean) => void;
  isDefaultOpen?: boolean;
  holdingIncomingOccupierHandler?: (id: string, value: string | boolean, type: string) => void;
  index: number,
  isMyInfoVariant: boolean,
  onBindMyInfo?: (nric: string, myInfoData: MyInfo) => void,
  onUnBindMyInfo?: (nric: string) => void,
  singpassToken?: string,
  forceError?: boolean,
  initialHouseholdNrics?: string[]
}


const ExistingUserFormsType1 = ({ ...props }: NewOccupierAccordionProps, itemHoldingErrors: any, allowToggle: boolean, allowRelated: boolean) => {
  const firstOwnerName = props.incoming_owners && props.incoming_owners.length > 0 ? props.incoming_owners[0].myinfo.name : "";

  const disableFields = !allowToggle && props.item.is_proposed;
  const handleValueChange = (id: string, key: string) => (value: string | boolean) => {
    props?.holdingIncomingOccupierHandler?.(id, value, key);
  }
  const isFirst = props.index === 0;

  return (
    <>
      <div style={{ marginTop: 12 }}><P2TextLabel bold="700" color={"#000"} label={"Relationship"} /></div>
        <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} disabled={disableFields} required selectedDropdown={props.item?.relationship_with_owner} placeholder="Please indicate relationship with owner" label={`How is this proposed occupier related to ${firstOwnerName}?`} items={incomingOwnerRelatedToAboveItems} setSelectedDropdown={handleValueChange(props.item.id, "relationship_with_owner")}/>
        </div>
      <div style={{ marginTop: isFirst ? 32 : 12 }}><P2TextLabel bold="700" color={"#000"} label={"Personal Details"} /></div>

      <div>
        <div style={{ marginTop: 24 }}>
          {/* <P2TextInput forceError={props.forceError} disabled={props.item?.is_proposed} isError={!itemHoldingErrors?.myinfo?.uinfin?.isValid} errorMsg={itemHoldingErrors?.myinfo?.uinfin?.message} required value={props.item?.myinfo?.uinfin?.toString()} name='uinfin' label='NRIC' maxLength={9} placeholder='Please enter NRIC' type='text' onChange={handleValueChange(props.item.id, "uinfin")} /> */}
          <IdForm forceError={props.forceError} item={props.item} disableFields={disableFields} handleValueChange={(value: any, field: string) => {
              handleValueChange(props.item.id, field)(value);
            }} itemHoldingErrors={itemHoldingErrors} />
        </div>

        <div style={{ marginTop: 24 }}>
          <P2TextInput pattern={namePattern} forceError={props.forceError} disabled required value={props.item?.myinfo?.name?.toString()} name='name' label='Full name' maxLength={256} placeholder='Please enter full name' type='text' />
        </div>
        <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} required disabled={disableFields} selectedDropdown={props.item?.myinfo?.sex} placeholder="Please indicate sex" label="Sex" variant="small" items={sexDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"sex")}
        />
        </div>
        <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} required disabled={disableFields} selectedDropdown={props.item?.myinfo?.race} placeholder="Please indicate race" label="Race" variant="small" items={raceDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"race")}
          />
        </div>
        <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} disabled={disableFields} required selectedDropdown={props.item?.myinfo?.residential_status} placeholder="Please indicate residential status" label="Residential status" items={incomingOwnerCitizenshipDropdownItems} setSelectedDropdown={handleValueChange(props.item.id, "residential_status")}
        />
        </div>
        <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} required disabled={disableFields || props.item?.myinfo?.residential_status === ResidentialStatusEnum.citizen} selectedDropdown={props.item?.myinfo?.nationality} placeholder="Please indicate nationality" label="Nationality" variant="small" items={nationalityDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"nationality")}
        />
        </div>
        <div style={{ marginTop: 24 }}>
          <P2DateSelector forceError={props.forceError} placeholder="DD/MM/YYYY" label="Date of birth" disabled={disableFields} isError={!itemHoldingErrors?.myinfo?.dob?.isValid} errorMsg={itemHoldingErrors?.myinfo?.dob?.message} value={props.item?.myinfo?.dob} required
            onChange={handleValueChange(props.item.id, "dob")}
          />
        </div>
        <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} disabled={disableFields} label="Marital status" required selectedDropdown={props.item?.myinfo?.marital_status} placeholder="Please indicate marital status" items={maritalStatusDropdownItems} setSelectedDropdown={handleValueChange(props.item.id, "marital_status")}
          />
        </div>

        <SpouseForm forceError={props.forceError} item={props.item} disableFields={disableFields} handleValueChange={(value: any, field: string) => {
          handleValueChange(props.item.id, field)(value);
        }} itemHoldingErrors={itemHoldingErrors} />
      </div>
    </>
  )
}

const NewUserForms = ({ ...props }: NewOccupierAccordionProps, itemHoldingErrors: any, allowToggle: boolean) => {
  const firstOwnerName = props.incoming_owners && props.incoming_owners.length > 0 ? props.incoming_owners[0].myinfo.name : "";

  const isAdditionalShow = itemHoldingErrors?.myinfo?.name?.isValid && itemHoldingErrors?.myinfo?.uinfin?.isValid;
  const isPersonalDetailsShow = props.item?.is_related === true ? props.item?.relationship_with_owner !== "" : props.item?.is_related !== undefined && !props.item?.is_related;

  const isFirst = props.index === 0;
  const disableFields = !allowToggle && props.item.is_proposed;

  const handleValueChange = (id: string, key: string) => (value: string | boolean) => {
    props?.holdingIncomingOccupierHandler?.(id, value, key);
  }
  return (
    <>
      <div style={{ marginTop: 12 }}><P2TextLabel bold="700" color={"#000"} label={"Relationship"} /></div>
        <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} disabled={disableFields} required selectedDropdown={props.item?.relationship_with_owner} placeholder="Please indicate relationship with owner" label={`How is this proposed occupier related to ${firstOwnerName}?`} items={incomingOwnerRelatedToAboveItems} setSelectedDropdown={handleValueChange(props.item.id, "relationship_with_owner")}/>
        </div>
      <div style={{ marginTop: isFirst ? 32 : 12 }}><P2TextLabel bold="700" color={"#000"} label={"Personal Details"} /></div>

      <div style={{ marginTop: isFirst ? 24 : 12 }}>
        {/* <P2TextInput forceError={props.forceError} disabled={props.item?.is_proposed} isError={!itemHoldingErrors?.myinfo?.uinfin?.isValid} errorMsg={itemHoldingErrors?.myinfo?.uinfin?.message} required value={props.item?.myinfo?.uinfin?.toString()} name='uinfin' label='NRIC' maxLength={9} placeholder='Please enter NRIC' type='text' onChange={handleValueChange(props.item.id, "uinfin")} /> */}
        <IdForm forceError={props.forceError} item={props.item} disableFields={disableFields} handleValueChange={(value: any, field: string) => {
              handleValueChange(props.item.id, field)(value);
        }} itemHoldingErrors={itemHoldingErrors} />
      </div>

      <div style={{ marginTop: 24 }}>
        <P2TextInput pattern={namePattern} forceError={props.forceError} disabled={disableFields} isError={!itemHoldingErrors?.myinfo?.name?.isValid} errorMsg={itemHoldingErrors?.myinfo?.name?.message} required value={props.item?.myinfo?.name?.toString()} name='name' label='Full name' maxLength={256} placeholder='Please enter full name' type='text' onChange={handleValueChange(props.item.id, "name")} />
      </div>
      {isAdditionalShow && <>
        {isPersonalDetailsShow && <>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} required disabled={disableFields} selectedDropdown={props.item?.myinfo?.sex} placeholder="Please indicate sex" label="Sex" variant="small" items={sexDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"sex")}
          />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} required disabled={disableFields} selectedDropdown={props.item?.myinfo?.race} placeholder="Please indicate race" label="Race" variant="small" items={raceDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"race")}
          />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} disabled={disableFields} required selectedDropdown={props.item?.myinfo?.residential_status} placeholder="Please indicate residential status" label="Residential status" items={incomingOwnerCitizenshipDropdownItems} setSelectedDropdown={handleValueChange(props.item.id, "residential_status")}
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} required disabled={disableFields || props.item?.myinfo?.residential_status === ResidentialStatusEnum.citizen} selectedDropdown={props.item?.myinfo?.nationality} placeholder="Please indicate nationality" label="Nationality" variant="small" items={nationalityDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"nationality")}
          />
          </div>
          <div style={{ marginTop: 24 }}>
            <P2DateSelector forceError={props.forceError} disabled={disableFields} isError={!itemHoldingErrors?.myinfo?.dob?.isValid} errorMsg={itemHoldingErrors?.myinfo?.dob?.message} value={props.item?.myinfo?.dob} required placeholder="DD/MM/YYYY" label="Date of birth" onChange={handleValueChange(props.item.id, "dob")}
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} disabled={disableFields} required selectedDropdown={props.item?.myinfo?.marital_status} placeholder="Please indicate marital status" label="Marital status" items={maritalStatusDropdownItems} setSelectedDropdown={handleValueChange(props.item.id, "marital_status")}
            />

            <SpouseForm forceError={props.forceError} item={props.item} disableFields={disableFields} handleValueChange={(value: any, field: string) => {
              handleValueChange(props.item.id, field)(value);
            }} itemHoldingErrors={itemHoldingErrors} />
          </div>      
  
        </>}

      </>
      }



    </>
  )
}



function NewOccupierAccordion({ ...props }: NewOccupierAccordionProps) {

  const AppDispatch = useAppDispatch();

  const isProposed = props.item ? props.item?.is_proposed : false;

  const accordionRef = useRef<any>();

  const handleValueChange = (id: string, key: string) => (value: string | boolean) => {
    props?.holdingIncomingOccupierHandler?.(id, value, key);
  }
  
  const formType = useMemo(() => {

    if (props.item.type === "existing" && props.index === 0 && props.isMyInfoVariant) {
      //Form 1 = when isMyInfoVariant and index = 0
      return 1;
    }
    if (props.item.type === "existing" && props.index > 0 && props.isMyInfoVariant) {
      //Form 2 = when isMyInfoVariant and index not 0

      return 2;
    }

    if (props.item.type === "existing" && props.index === 0 && !props.isMyInfoVariant) {
      //Form 3 = when not isMyInfoVariant and index is 0 or greater
      //used by owner 2...n when index is 0
      return 1;
    }
    if (props.item.type === "existing" && props.index > 0 && !props.isMyInfoVariant) {
      //Form 4 = when not isMyInfoVariant and index is 0 or greater
      //used by subsequence existing owner/occupier with 
      return 4;
    }


    if (props.item.type === "new") {
      return 5;
    }

  }, [props.item.type])
  const [allowToggle, setAllowToggle] = useState<boolean>(false);
  
  
  const [saveAlertShow, setSaveAlertShow] = useState<boolean>(false);
  const [isInit, setIsInit] = useState<boolean>(false);
  const accordionEventRef = useRef<any>();


  const bindProcess = useCallback((res: any) => {
    const errorMessage = "We are unable to retrieve from MyInfo. Please input your personal information.";
    if(isNaN(res.payload)){
      const myInfoData: MyInfo = new MyInfo({ ...res.payload, uinfin: PolymerCrypto.decryption(res.payload.uinfin) });
      if(myInfoData.dob && myInfoData.dob.split("-").length < 3) {
        setRetrieve(false)
        alert(errorMessage)
        return;
      }
      if (props.onBindMyInfo && props.item.original_uinfin) {
        props.onBindMyInfo(props.item.original_uinfin, myInfoData);
      }
    } else {
      setRetrieve(false)
      alert(errorMessage)
    }
  }, [props])

  const { isRetrieve, isMyInfoLoading, toShowMyInfo, toggleRetrieveMyInfo, myInfoLoadingValue, setRetrieve } = useRetrieveMyInfo(props.item, allowToggle, () => {
    AppDispatch(retrieveMyInfoByNRIC({ uinfin: props.item.original_uinfin, singpass_code: props.singpassToken, allow_my_info: true })).then(bindProcess).finally(() => {
      myInfoLoadingValue(false);
    });
  }, () => {
    AppDispatch(retrieveMyInfoByNRIC({ uinfin: props.item.original_uinfin, singpass_code: props.singpassToken, allow_my_info: false })).finally(() => {
      if (props.onUnBindMyInfo && props.item.original_uinfin) {
        props.onUnBindMyInfo(props.item.original_uinfin);
      }
    }).finally(() => {
      myInfoLoadingValue(false);
    });
  });


  const { errors: itemHoldingErrors, formValid: itemHoldingFormValid, setFormValue: itemHoldingSetFormValue, setAdditionalData }: { handleChange: any, values: HoldingOccupier, errors: any, formValid: boolean, setFormValue: (update: any) => void, setAdditionalData: any } = useForm(new HoldingOccupier(props.item), () => { }, validateIndividualHoldingOccupier);

  const isEnableBtn = useMemo(() => {
    return !itemHoldingFormValid;
  }, [itemHoldingFormValid])

  useEffect(() => {
    setAdditionalData({ "formType": formType, "reasonValues": props.reasonValues, proposed_nric: props.proposed_nric, isFirst: props.index === 0, initialHouseholdNrics: props.initialHouseholdNrics });
    itemHoldingSetFormValue(props.item)
  }, [props.item, props.index, , formType, props.reasonValues]);

  useEffect(() => {
    if ((formType === 5 && props.index === 0)) {
      props.holdingIncomingOccupierHandler!(props.item.id, true, "is_related");
    }
  }, [formType])

  const handleToggle = useCallback((isOpen: boolean) => {
    props?.onToggle?.(isOpen);
  }, []);

  const handleAddingOccupier = useCallback(() => {
    if (props.onAdd) {
      props.onAdd();
      accordionRef.current.toggle();
    }
  }, [props.onAdd, accordionRef.current])

  const handleOccupierUpdate = useCallback(() => {
    setAllowToggle(false);
    setSaveAlertShow(false);
    setIsInit(false);
    if (props.onUpdate) {
      props.onUpdate();
    }
  }, [props.onUpdate]);



  const handleClickOutside = useCallback((event:any) => {
    if((isProposed && allowToggle) && isInit === false){
      setIsInit(true);
    }
    else{
      if (accordionEventRef.current && !accordionEventRef.current.contains(event.target)) {
        if(!isEnableBtn){
          setSaveAlertShow(true);
        }
      }
      else{
        setSaveAlertShow(false);
        setIsInit(false);
      }
    }

  },[allowToggle, isEnableBtn, isInit, isProposed]);

  const toggleEditDetails = useCallback(() => {
    setAllowToggle(true);
    setSaveAlertShow(false);
  }, []);



  const saveAlertVisible = useMemo(()=>{
    if(((isProposed && allowToggle)) && !isEnableBtn && saveAlertShow && isInit){
      return true;
    }
    else if(!isProposed && !isEnableBtn && saveAlertShow){
      return true;

    }
    else{
      setSaveAlertShow(false);
      return false;
    }
  },[allowToggle, isEnableBtn, isInit, isProposed, saveAlertShow])

  useEffect(() => {
    // Add click event listener to the document
    document.addEventListener('click', handleClickOutside);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]); 



  return (
    <div ref={accordionEventRef}>

      <P2Accordion ref={accordionRef} defaultOpen={props.isDefaultOpen} onToggle={handleToggle} title={
        <AccordionTitle isProposed={true} item={props.item} type='occupier' />
      }>
        <p hidden aria-hidden>{formType}</p>

        {isMyInfoLoading && <>
          <LottieLoader />
        </>}

        {!isMyInfoLoading &&
          <>
            <div>
              {toShowMyInfo && <SingpassMyInfo hasRetrieve={isRetrieve} onClick={toggleRetrieveMyInfo} />}
              {(formType === 1 || formType === 2) && ExistingUserFormsType1(props, itemHoldingErrors, allowToggle, true)}
              {formType === 4 && ExistingUserFormsType1(props, itemHoldingErrors, allowToggle, true)}
              {formType === 5 && NewUserForms(props, itemHoldingErrors, allowToggle)}
            </div>

            {saveAlertVisible && <div style={{ marginTop: 24 }}>
              <P2Alert variant={"danger"} text={"Please save details to proceed."}></P2Alert>
            </div>}

            <div className="polymer-buttons-wrapper">
              <P2Button onClick={props.onRemove} variant={"text-icon"} style={{ fontSize: '1rem' }}>Delete record</P2Button>
              {!isProposed && <P2Button disabled={isEnableBtn} onClick={handleAddingOccupier} variant={"outline-primary"}>Save details</P2Button>}
              {isProposed && allowToggle && <P2Button disabled={isEnableBtn} onClick={handleOccupierUpdate} variant={"outline-primary"}>Save details</P2Button>}
              {isProposed && !allowToggle && <P2Button disabled={isEnableBtn} onClick={toggleEditDetails} variant={"outline-primary"} style={{ fontSize: '1rem' }}>Edit details</P2Button>}
            </div>
          </>}

      </P2Accordion>
    </div>
  )
}

export default NewOccupierAccordion